module.exports = __webpack_public_path__ + "static/img/dev2.91b065a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/dev2.jpg
// module id = KVJD
// module chunks = 3